export const RegistrationElements = {
    MSISDN: "msisdn",
    EMAIL: "email",
    ID_TYPE: "id-type",
    ID_NUMBER: "id-number",
    ID_EXPIRY: "id-expiry-date",
    ID_DOCUMENT: "identity-document",
    SELFIE_DOCUMENT: "picture",
    FIRST_NAME: "first-name",
    LAST_NAME: "last-name",
    DOB: "dob",
    GENDER: "gender",
    NATIONALITY: "nationality",
    STREET_NUMBER: "street-number",
    STREET_NAME: "street-name",
    TOWN: "town",
    CITY: "city",
    PROVINCE: "province",
    POSTAL_CODE: "postal-code",
    CONTEXT: "context",
    CONTEXT_ID: "context-id",
    REGISTRATION_TYPE: "registration-type",
    INBOUND_LIMIT_TIER_SET_ID : "inbound-limit-tier-set-id",
    INBOUND_LIMIT_TIER_SET_NAME: "inbound-limit-tier-set-name",
    INBOUND_LIMIT_DOCUMENT_PURPOSES: "inbound-limit-document-purposes",
    INBOUND_LIMIT_DOCUMENT_TYPE_IDS: "inbound-limit-document-type-ids",
    INBOUND_LIMIT_DOCUMENT_METADATA_IDS: "inbound-limit-document-metadata-ids",
    ADDITIONAL_DOCUMENT_PURPOSES: "additional-document-purposes",
    ADDITIONAL_DOCUMENT_TYPE_IDS: "additional-document-type-ids",
    ADDITIONAL_DOCUMENT_METADATA_IDS: "additional-document-metadata-ids",
    REPORTING_DECLARATION_SIGNED: "reporting-declaration-signed",
    REPORTING_DECLARATION_VERSION: "reporting-declaration-version",
}